import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-dialog-input',
    templateUrl: './dialog-input.component.html',
    styleUrls: ['./dialog-input.component.scss'],
    standalone: false
})
export class DialogInputComponent implements OnInit {


  @Input() public message: string = 'Please enter a value';
  @Input() public value: string = '';
  @Input() public placeholder: string = '';

  safeMessage: SafeHtml;

 // Inject the active modal reference
  constructor(public activeModal: NgbActiveModal, private sanitizer: DomSanitizer) {}

  onConfirm(): void {
    // Use 'close()' to resolve the result promise with the value
    this.activeModal.close(this.value);
  }

  onCancel(): void {
    // Use 'dismiss()' to reject the result promise with 'false' or null
    this.activeModal.dismiss(null);
  }
  ngOnInit() {
    this.safeMessage = this.sanitizer.bypassSecurityTrustHtml(this.message);
  }

}
